var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = ["1", "2"].includes(_vm.state)

  var l0 = _vm.__map(_vm.detail.contentsList, function(t, __i0__) {
    var m0 = parseInt(t.dayNum)
    var m1 = decodeURI(t.content)
    return {
      $orig: _vm.__get_orig(t),
      m0: m0,
      m1: m1
    }
  })

  var m2 = require("static/strategy/labels.png")

  var m3 = require("static/strategy/story.png")

  var l2 = _vm.__map(_vm.mainBody, function(t, i) {
    var l1 = _vm.__map(t.imgs.split(","), function(tt, ii) {
      var m4 = _vm.$getImg(tt)
      return {
        $orig: _vm.__get_orig(tt),
        m4: m4
      }
    })

    return {
      $orig: _vm.__get_orig(t),
      l1: l1
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        m2: m2,
        m3: m3,
        l2: l2
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }